import ClassNames from "classnames";
import { FunctionComponent } from "react";
import { selectActiveSite } from "../../selectors/sites.js";
import { useAppSelector } from "../../store/hooks.js";
import styles from "../../stylesheets/components/weather-module.module.css";
import {
  BaseModuleProps,
  ColorScheme,
  WeatherModuleSettings,
} from "../../types/index.js";
import ModuleHeadings from "../ModuleHeadings.js";
import ModuleWithHeadings from "../ModuleWithHeadings.js";
import WeatherWidget from "../WeatherWidget.js";

interface Props extends BaseModuleProps<WeatherModuleSettings> {
  scheme: ColorScheme;
}

const WeatherModule: FunctionComponent<Props> = ({
  translatedModule: {
    id,
    settings: { textAlign, districtId, iconStyle },
    translation: {
      languageId,
      settings: { title, subtitle },
    },
  },
  scheme,
  isFirstOnPage,
}) => {
  const site = useAppSelector(selectActiveSite);
  const settings = {
    propertyId: site.accommodation.id,
    lang: languageId,
    colorScheme: scheme,
    districtId,
    iconStyle,
  };

  return (
    <ModuleWithHeadings
      title={title}
      subtitle={subtitle}
      id={id}
      className={ClassNames(
        textAlign.description !== "justify" &&
          styles[`WeatherModule--align-${textAlign.description}`],
      )}
      colors={{ background: settings.colorScheme.main.background }}
    >
      <ModuleHeadings
        scheme={settings.colorScheme}
        isFirstOnPage={isFirstOnPage}
        textAlign={textAlign}
        title={title}
        subtitle={subtitle}
      />

      <WeatherWidget settings={settings} />
    </ModuleWithHeadings>
  );
};

export default WeatherModule;
